import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import AntiCorruption from '../components/Achievements/AntiCorruption';
import Introduction from '../components/Achievements/Introduction';
import Privacy from '../components/Achievements/Privacy';
import Download from '../components/Home/Download';
import AchievementsBanner from '../components/Achievements/AchievementsBanner';
import Infrastructure from '../components/Achievements/Infrastructure';
import { isMobileContext } from '../components/context/isMobileContext';
export default function Environment() {
  const { t } = useTranslation();
  const { isMobile } = useContext(isMobileContext)
  const bannerData = {
    our: t("environment_page.banner.our"),
    headline1: t("environment_page.banner.headLine1"),
    headline2: t("environment_page.banner.headLine2-1"),
    description: t("environment_page.banner.description"),
    worldClass: t("environment_page.banner.world_class"),
    // worldClass1: t("environment_page.banner.world_class1"),
    img: '/imgs/achievements/environment-banner.png'
  }
  const pollutionData = {
    title1: t("environment_page.Pollution.line1"),
    desc: t("environment_page.Pollution.description1"),
    cardsData: [
      {
        title: t("environment_page.Pollution.card1"),
        img: t("environment_page.Pollution.img1"),
        // img_Ar: '/imgs/achievements/environment/graphs/waste/ar/Waste-Generated-Graphs2.png',
      },
      {
        title: t("environment_page.Pollution.card2"),
        img: t("environment_page.Pollution.img2"),
        // img_Ar: '/imgs/achievements/environment/graphs/waste/ar/Waste-Generated-Graphs1.png',
      },
      {
        title: t("environment_page.Pollution.card3"),
        img: t("environment_page.Pollution.img3"),
        // img_Ar: '/imgs/achievements/environment/graphs/waste/ar/Waste-Diverted-Landfill.png',
      }, 
      {
        title: t("environment_page.Pollution.card4"),
        img: t("environment_page.Pollution.img4"),
        // img_Ar: '/imgs/achievements/environment/graphs/waste/ar/Waste-Diverted-Landfill-Graphs2.png',
      },
      {
        title: t("environment_page.Pollution.card5"),
        img: t("environment_page.Pollution.img5"),
        // img_Ar: '/imgs/achievements/environment/graphs/waste/ar/Waste-Directed-Disposal.png',

      },
      {
        title: t("environment_page.Pollution.card6"),
        img: t("environment_page.Pollution.img6"),
        // img_Ar: '/imgs/achievements/environment/graphs/waste/ar/CO2-Reduced.png',
      },
    ]
  }
 
  const qualityData = {
    line1: t("environment_page.Quality.line1"),
    line2: t("environment_page.Quality.line2"),
    descriptions: [t("environment_page.Quality.description1")],
    img: t("environment_page.Quality.img"),
    // img_Ar: '/imgs/achievements/environment/graphs/waste/ar/Air-Quality.png', 
  }  

  const contributionData = {
    line1: t("environment_page.Contribution.line1"),
    line2: t("environment_page.Contribution.line2"),
    line3: t("environment_page.Contribution.line3"),
    descriptions: [
      t("environment_page.Contribution.description1"),
      t("environment_page.Contribution.description2"),
      t("environment_page.Contribution.description3"),
    ],
    img: '/imgs/achievements/environment/contribute.png'
  }

  const climateData = {
    line1: t("environment_page.Climate.line1"),
    line2: t("environment_page.Climate.line2"),
    descriptions: [t("environment_page.Climate.description1")],
    img: t("environment_page.Climate.img"),
    // img_Ar: '/imgs/achievements/environment/graphs/waste/ar/Our-Emissions.png',
  }
  const biodiversityData = {
    line1: t("environment_page.Biodiversity.line1"),
    descriptions: [
      t("environment_page.Biodiversity.description1"),
      t("environment_page.Biodiversity.description2"),
      t("environment_page.Biodiversity.description3"),
    ],
    img: '/imgs/achievements/environment/biod.png'
  }
  // const qualityData = {
  //   subtitle: t("environment_page.Quality.line1"),
  //   title1: t("environment_page.Quality.line2"),
  //   desc: t("environment_page.Quality.description1"),
  //   cardsData: [
  //     {
  //       title: t("environment_page.Quality.card1"),
  //       img: '/imgs/achievements/environment/graphs/Air-Quality.svg'
  //     }
  //   ]
  // }
  // const climateData = {
  //   subtitle: t("environment_page.Climate.line1"),
  //   title1: t("environment_page.Climate.line2"),
  //   desc: t("environment_page.Climate.description1"),
  //   cardsData: [
  //     {
  //       title: t("environment_page.Climate.card1"),
  //       img: '/imgs/achievements/environment/graphs/Our-Emissions.svg'
  //     }
  //   ]
  // } 
  return (
    <div>
      <Helmet>
        <title>{t('head.environment')}</title>
      </Helmet>
      <AchievementsBanner bannerData={bannerData} uniqueClass={"environment"} environmentPage />
      <Infrastructure data={pollutionData} section={"infraSection"} environmentLayer2  uniqueClass={"environment"} />
      <Privacy data={qualityData} invertedSection desktopLayer={isMobile?false:true} normalSwiperLayers={isMobile?true:false}   airQuailty qualityData  uniqueClass={"environment"} />
      {/* <Infrastructure data={qualityData} section={"happinessSection"} invertedSwiper uniqueClass={"environment"} /> */}
      <Privacy data={contributionData} environmentLayer2={isMobile?false:true} environmentBg environmentMobileLayer={isMobile?true:false}  contribution uniqueClass={"environment"} />
      <Privacy data={climateData} climate  airQuailty  environmentMobileLayer={isMobile?true:false}   invertedSection uniqueClass={"environment"} />
      {/* <Infrastructure data={climateData} environmentLayer section={"happinessSection"} invertedSwiper uniqueClass={"environment"} /> */}
      <Privacy data={biodiversityData} biodiversity environmentLayer removeImg={isMobile?true:false}  uniqueClass={"environment"} />
      {/* <Download /> */}
    </div>
  )
}
